import React from 'react'
import Utils from 'Utils'
import axios from 'axios'
import Matrix from 'scripts/Matrix'
import utils from '../../Utils'
import { Redirect } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import ModalAlert from '../ModalAlert'
import CallIcon from '@material-ui/icons/Call'
import ChatIcon from '@material-ui/icons/Chat'
import VideocamIcon from '@material-ui/icons/Videocam'




class ConsultItemPatient extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      consult: props.consult,
      clientData: props.clientData,
      redirect: false,
      consultRequest: {},
      exp: null,
      spl: null
    }

  }

  componentDidMount() {
    this.setState({ redirect: false })
    if (this.state.consult.doctor && this.state.consult.doctor.spUnis && this.state.consult.doctor.spUnis.length > 0)
      this.setState({ spl: this.state.consult.doctor.spUnis[0] })

    if (this.state.consult.doctor && this.state.consult.doctor.expUnis && this.state.consult.doctor.expUnis.length > 0)
      this.setState({ exp: this.state.consult.doctor.expUnis[0] })
  }

  handleOnClick = () => {
    // if (this.state.consult.status !== 'initiated') return
    const { consult } = this.state

    if (consult.status === 'rejected') return this.props.onRowClick('علت رد شدن', consult.rejectReason)
   // if (consult.type === 'text' && consult.status === 'initiated') {
    if (consult.status === 'initiated' || consult.status === 'asked') {
      axios.get(utils.urls.consultRequsetWaitingForPayment(this.props.consult.id), {
        headers: {
          'x-access-token': Matrix.getToken()
        }
      })
        .then(res => {
          const pathname = consult.status === 'asked' ? '/question' : '/consult/new'

          this.setState({
            redirect: { pathname, state: { consultRequest: res.data.consultRequest, doctor: res.data.consultRequest.doctor } }
          })
        })
        .catch(err => console.log(err))
    }
  }


  // apiDeleteConsult = async () => {
  //   let res = await axios.delete(utils.urls.consultRequsetWaitingForPayment(this.state.consult.id), {
  //     headers: {
  //       'x-access-token': Matrix.getToken()
  //     }
  //   })
  //     .catch((e) => {
  //       console.log(e)
  //       let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
  //       this.SnackBar.openSnackbar(message)
  //     });

  //   if (!res) return
  //   const { success } = res.data
  //   this.props.onDeleteConsult(this.state.consult.id)
  //   if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
  // }

  showRoomIcon = () => {
    const { type } = this.state.consult

    if (type === 'text') return <ChatIcon />
    if (type === 'voice') return <CallIcon />
    if (type === 'video') return <VideocamIcon />
  }

  className = () => {
    const { status, type } = this.state.consult

    if (status === 'initiated') {
      return 'waiting'
//       if (type === 'text') return 'waiting'
//       if (type === 'voice') return 'asked'
    }
    if (status === 'asked') return 'asked'
    if (status === 'rejected') return 'reject'
  }

  consultStatus = consult => {
    const { status, type } = consult

    if (status === 'initiated') {
      return 'منتظر پرداخت'

//       if (type === 'text') return 'منتظر پرداخت'
//       if (type === 'voice') return 'منتظر تماس'
    }
    if (status === 'asked'){
      if (type === 'text') return 'منتظر پاسخ'
      if (type === 'voice') return 'منتظر تماس'
      if (type === 'video') return 'منتظر تماس'
    }
    if (status === 'rejected') return 'رد شده'
  }

  linkToDoctorProfile = e => {
    if (!this.props.consult.doctorId) return

    e.stopPropagation()
    this.setState({ redirect: `/doctors/${this.props.consult.doctorId}` })
  }

  render() {
    const { consult } = this.state

    if (this.state.redirect) {
      return <Redirect push={true} to={this.state.redirect} />
    }

    return (
      <div className='container' style={{ height: '100px', position: 'relative', background: '#f9f9f9' }} onClick={() => this.handleOnClick()}>
        {/* <SnackBar ref={el => { this.SnackBar = el }} /> */}
        {/* <ModalAlert ref={el => this.modalAlert = el} action={this.apiDeleteConsult} /> */}
        <div style={{ position: 'absolute', backgroundColor: '#1dc37e', minWidth: '5px', minHeight: '100%', right: '0px' }} />
        <div className="rooms-image" onClick={this.linkToDoctorProfile}>
          {consult.doctor ?
            consult.doctor.url ?
              <img src={Utils.doctorImageUrl(consult.doctor.url)} /> :
              <img src="/images/person.svg" /> :
            <img src={consult.ConsultCategory.path?`https://www.tebinja.com${consult.ConsultCategory.path}`:`/images/icons/category-icon/${consult.ConsultCategory.id}.png`} />
          }
        </div>
        <div className="rooms-detail">
          <div className="rooms-name-date">
            <div className="rooms-name">
              {this.showRoomIcon()}
              {this.state.consult.ConsultCategory ?
                <p style={{ fontSize: '12px', color: '#333', fontWeight: 'bold' }}>
                  {'درخواست مشاوره ' + this.state.consult.ConsultCategory.name || 'درخواست مشاوره'}
                </p> :
                <p style={{ fontSize: '12px', color: '#333', fontWeight: 'bold' }}>
                  {'درخواست مشاوره ' + `${this.state.consult.doctor.fname} ${this.state.consult.doctor.lname}` || 'درخواست مشاوره'}
                </p>
              }
              <div style={{ flex: 1 }}></div>
              <span
                className={this.className()}
                style={{ fontSize: '12px', borderRadius: '4px', padding: '0 5px' }}
                onClick={this.handleOnClick}
              >
                {this.consultStatus(consult)}
              </span>
              {/* {(this.state.consult.ConsultCategory &&
                <p style={{ fontSize: '12px', padding: '0 4px', borderRadius: '4px', backgroundColor: '#1dc37e', color: '#fff', display: 'inline' }}>
                  {'درخواست مشاوره ' + this.state.consult.ConsultCategory.name || 'درخواست مشاوره'}
                </p>)
              }
              {!this.state.consult.ConsultCategory && this.state.consult.doctor &&
                <p style={{ fontSize: '12px', padding: '0 4px', borderRadius: '4px', backgroundColor: '	#048a81', color: '#fff', display: 'inline' }}>
                  {'درخواست مشاوره ' + `${this.state.consult.doctor.fname} ${this.state.consult.doctor.lname}` || 'درخواست مشاوره'}
                </p>
              } */}
            </div>
          </div>
          <div className="rooms-last-content spl">
            {!this.state.exp && this.state.spl &&
              <p key={this.state.spl.id} className='rtl' style={{ flexGrow: 1, lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
                {'متخصص ' + this.state.spl.specialty.name}
              </p>
            }
            {this.state.exp &&
              <p key={this.state.exp.expertise.id} className='rtl' style={{ flexGrow: 1, lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
                {'فوق تخصص ' + this.state.exp.expertise.name}
              </p>
            }
            <div style={{ flex: 1 }}></div>
            <div className="rooms-date">
              <span>
                {Utils.getJalaiData(new Date) === Utils.getJalaiData(this.state.consult.createdAt) ?
                  Utils.timeStampToHHMM(this.state.consult.createdAt) :
                  Utils.getJalaiData(this.state.consult.createdAt)}
              </span>
            </div>
          </div>
          <div className="rooms-last-content">
            <p className='rtl' style={{ flexGrow: 1, lineHeight: '20px', maxHeight: '20px', overflow: 'hidden' }}>
              {this.state.consult.question}
            </p>
            <span style={{ flex: 1 }}></span>
            {consult.status === 'initiated' &&
              <span className="delete-consult" onClick={e => {
                e.stopPropagation()
                this.props.openModal({ id: this.state.consult.id })
              }}>
                <span>حذف</span>
                <CloseIcon style={{ fontSize: 12, marginRight: 5 }} />
              </span>
            }

          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: 10, margin: '0 5px' }}>{consult.status === 'rejected' && 'مبلغ به حساب شما بازگردانده شد '}</span>
          </div>
        </div>
      </div >
    )
  }
}
export default ConsultItemPatient
